import { Link } from "react-router-dom";
import { Star, Quote, ArrowUpRight } from "lucide-react";
import { REVIEWS } from "@/data/content";

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-24 lg:py-32 border-t border-[#262626] bg-[#0A0A0A]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-7">
            <div className="text-xs tracking-[0.24em] uppercase text-white/60 mb-4">
              — Word on the Street
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold leading-[0.95]">
              Five-star work,
              <br />
              <span className="text-white/40">every service call.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:text-right">
            <div className="inline-flex items-center gap-3 border border-[#262626] px-5 py-3">
              <div className="flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-[#E60000] fill-[#E60000]"
                    strokeWidth={0}
                  />
                ))}
              </div>
              <span className="text-sm text-white/80">
                <span className="font-bold">5.0</span> average rating
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#262626] border border-[#262626]">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`review-${i}`}
              className="bg-[#0A0A0A] p-8 md:p-10 flex flex-col justify-between hover:bg-[#141414] transition-colors"
            >
              <div>
                <Quote className="w-6 h-6 text-[#E60000] mb-4" strokeWidth={2} />
                <blockquote className="font-display text-lg md:text-xl leading-snug tracking-tight text-white">
                  “{r.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-8 pt-6 border-t border-[#262626] flex items-center justify-between">
                <div>
                  <div className="text-sm font-bold">{r.name}</div>
                  <div className="text-xs text-white/50 tracking-wide mt-0.5">
                    {r.role}
                  </div>
                </div>
                <div className="flex">
                  {Array.from({ length: r.stars }).map((_, j) => (
                    <Star
                      key={j}
                      className="w-3.5 h-3.5 text-[#E60000] fill-[#E60000]"
                      strokeWidth={0}
                    />
                  ))}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/reviews"
            data-testid="see-all-reviews-cta"
            className="inline-flex items-center gap-2 border border-[#262626] hover:border-white text-white font-bold px-6 py-4 text-sm transition-colors"
          >
            Read all reviews <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </section>
  );
}
